export function isObject(value: unknown) {
	return typeof value === 'object' && !Array.isArray(value) && value !== null;
}

export function getNestedObjectProp(data: object, prop: string): unknown {
	return Object.entries(data).reduce((result: unknown, [key, value]) => {
		if (result !== undefined && result !== null) {
			return result;
		}

		if (key === prop) {
			return value;
		}

		if (isObject(value)) {
			return getNestedObjectProp(value, prop);
		}

		return null;
	}, null);
}
